export default "__VITE_ASSET__CDgiD6CP__"